import createLucideIcon from '../createLucideIcon';

const Monitor = createLucideIcon('Monitor', [
  [
    'rect',
    {
      width: '20',
      height: '14',
      x: '2',
      y: '3',
      rx: '2',
      ry: '2',
      key: 'b7pjzu',
    },
  ],
  ['line', { x1: '8', x2: '16', y1: '21', y2: '21', key: '1svkeh' }],
  ['line', { x1: '12', x2: '12', y1: '17', y2: '21', key: 'vw1qmm' }],
]);

export default Monitor;
